import type VueRouter from 'vue-router';
import type { Pinia } from 'pinia';
import clearAllAppBackGuard from './clearAllAppBack';
import appInfoGuard from './appInfo';
import loginGuard from './login';
import transferQueriesGuard from './transferQueries';
import referrerGuard from './referrer';
import bodyStyleGuard from './bodyStyle';
import titleGuard from './title';
import { setupRegisterPageGuard, trackPageViewGuard } from './tracker';
import blankCheckerGuard from './blankChecker';

export function installGuards(router: VueRouter, pinia: Pinia) {
  /**
   * 顺序有要求，请勿随意调整
   */
  [
    clearAllAppBackGuard, // beforeEach
    appInfoGuard, // beforeEach
    transferQueriesGuard, // beforeEach
    loginGuard, // beforeEach
    referrerGuard, // beforeEach
    setupRegisterPageGuard, // beforeEach
    bodyStyleGuard, // afterEach
    titleGuard, // afterEach
    trackPageViewGuard, // afterEach
    blankCheckerGuard, // afterEach
  ].forEach((guard) => guard(router, pinia));
}
